import {z} from 'zod';

export enum ThumbnailType {
  User = '1',
  Site = '2',
  Asset = '3',
  Project = '4',
  ReportLogo = '5',
  ReportCover = '6',
}
export const thumbnailMimeTypes: z.core.util.MimeTypes[] = [
  'image/jpeg',
  'image/png',
  'image/webp',
] as const;

export const singleFileSchema = z.object({
  // in memory file that isn't uploaded yet
  file: z
    .file()
    // .mime(thumbnailMimeTypes)
    .nullable(),
  // url to render image, could be server url or blob url for file property
  displayUrl: z.string(),
  // did an image already exist when starting the form session
  hasInitialValue: z.boolean(),
  // used to determine if the image is being removed
  isCleared: z.boolean(),
});
export const thumbnailRequiredSchema = singleFileSchema
  .extend({
    file: z
      .file()
      .mime(thumbnailMimeTypes)
      .max(1024 * 1024 * 100)
      .nullable(), // 100 MB max file size
  })
  .refine(
    ({file, hasInitialValue, isCleared}) =>
      file || (hasInitialValue && !isCleared),
    {
      message: 'Thumbnail is required',
    }
  );

export type SingleFileInputValue = z.infer<typeof singleFileSchema>;

export function formatThumbnailBody(
  id: string,
  type: ThumbnailType,
  {file, isCleared, hasInitialValue}: SingleFileInputValue
): FormData | null {
  const isRemoving = hasInitialValue && isCleared;

  if (!isRemoving && !file) {
    return null;
  }

  const body = new FormData();
  body.append('id', id);
  body.append('type', type);
  body.append('isRemoving', isRemoving.toString());
  file && body.append('file', file);

  return body;
}
